<template src="./mappingScreen.template.html"></template>
<script>
    import foliomodal from "../../reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue";
    export default {
        name: 'mappingScreen',
        props: ['selectedIntegration', 'redirectToRentalsUnited', 'ruClientName', 'intigrationClientDetails'],
        components: {
            foliomodal
        },
        data() {
            return {
                // Data
                searchText: "",
                isFilterOptionSelected: false,
                selectedFilter: "All",
                isNoResultDisplay: false,
                timeout: null,
                viewOptionsList: [
                    { name: "Active", isChecked: false },
                    { name: "Inactive", isChecked: false },
                    { name: "Create Unit", isChecked: false },
                    { name: "Create Property in RU", isChecked: false },
                    { name: "All", isChecked: true }
                ],
                RU_PropertyDetailList: [],
                UnlinkUnitList: [],
                UnLinkedPropertyDetailList: [],
                RU_UserLoginList: [],
                headerColumnList: {
                    TEMPO: { Label: "TEMPO", IsChecked: true, ColumnName: "TEMPO" },
                    RENTALSUNITED: {
                        Label: "RENTALSUNITED",
                        IsChecked: true,
                        ColumnName: "RENTALS UNITED"
                    },
                    CHANNELS: {
                        Label: "CHANNELS",
                        IsChecked: true,
                        ColumnName: "CHANNELS"
                    },
                    STATUS: { Label: "STATUS", IsChecked: true, ColumnName: "STATUS" }
                },
                RUPropertyStatusList: [
                    {
                        statusName: "Pull data",
                        statusId: 1
                    },
                    {
                        statusName: "Push data",
                        statusId: 2
                    },
                    {
                        statusName: "Activate",
                        statusId: 3
                    },
                    {
                        statusName: "InActivate",
                        statusId: 4
                    },
                    {
                        statusName: "Create Unit",
                        statusId: 5
                    },
                    {
                        statusName: "Push Inventory, Rates, Restrictions",
                        statusId: 6
                    }
                ],
                selectedRUProperty: {},
                selectedStatusId: 0,
                isModalVisible: false,
                modalParams: {},
                isDropdownOpen: false

            };
        },
        methods: {
            // Methods
            getCrsPropertyListBySearchText(value) {
                let vm = this;
                if (((value.which <= 90 && value.which >= 48) || value.which == 8 || value.which == 46) && value.code != "MetaLeft") {
                    clearTimeout(vm.timeout);
                    vm.timeout = setTimeout(function () {
                        vm.updateRUClientDetailList(vm.RU_UserLoginList[0].UserName)
                    }, 2000);
                }
            },
            updateRUClientDetailList(userName, searchValue, filterValue) {
                var vm = this;
                vm.selectedFilter = filterValue != undefined ? filterValue : vm.selectedFilter
                if (searchValue != undefined) {
                    vm.searchText = searchValue
                }
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetCrsPropertyList",
                    params: {
                        username: userName,
                        SearchText: vm.searchText
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("Error in GetCrsPropertyList => ", err);
                            return;
                        }
                        if (response) {
                            console.log("response in GetCrsPropertyList", response);
                            var mergedResponse = [];
                            vm.isNoResultDisplay = true;

                            let crsPropertyList = response.recordsets[2]
                            let unitList = response.recordsets[1]
                            let userLoginList = response.recordsets[4]
                            //if (vm.isFilterOptionSelected) {
                            var list = [];

                            if (vm.selectedFilter == "Active") {
                                var activeList = crsPropertyList.filter(function (mapped) {
                                    return mapped.IsConnected == 1;
                                });
                                list = list.concat(activeList);
                                vm.RU_PropertyDetailList.splice(0, vm.RU_PropertyDetailList.length, ...list);
                                vm.UnlinkUnitList.splice(0, vm.UnlinkUnitList.length);
                            } else if (vm.selectedFilter == "Inactive") {
                                var inactiveList = crsPropertyList.filter(function (mapped) {
                                    return mapped.IsConnected == 0 && mapped.UnitName != null;
                                });
                                list = list.concat(inactiveList);
                                vm.RU_PropertyDetailList.splice(0, vm.RU_PropertyDetailList.length, ...list);
                                vm.UnlinkUnitList.splice(0, vm.UnlinkUnitList.length);
                            } else if (vm.selectedFilter == "Create Unit") {
                                var createUnitList = crsPropertyList.filter(function (mapped) {
                                    return mapped.IsConnected == 0 && mapped.UnitName == null;
                                });
                                list = list.concat(createUnitList);
                                vm.RU_PropertyDetailList.splice(0, vm.RU_PropertyDetailList.length, ...list);
                                vm.UnlinkUnitList.splice(0, vm.UnlinkUnitList.length);
                            } else if (vm.selectedFilter == "Create Property in RU") {
                                vm.RU_PropertyDetailList.splice(0, vm.RU_PropertyDetailList.length, ...list);
                                vm.UnlinkUnitList.splice(0, vm.UnlinkUnitList.length, ...response.recordsets[5]);
                            } else if (vm.selectedFilter == "All") {
                                vm.RU_PropertyDetailList.splice(0, vm.RU_PropertyDetailList.length, ...crsPropertyList);
                                vm.UnlinkUnitList.splice(0, vm.UnlinkUnitList.length, ...response.recordsets[5]);
                            }
                            //} else if (vm.selectedFilter == "All") {
                            //  vm.RU_PropertyDetailList.splice(0, vm.RU_PropertyDetailList.length, ...crsPropertyList);
                            //  vm.UnlinkUnitList.splice(0, vm.UnlinkUnitList.length, ...response.recordsets[5]);
                            //}
                            vm.UnLinkedPropertyDetailList.splice(0, vm.UnLinkedPropertyDetailList.length, ...unitList);
                            vm.RU_UserLoginList.splice(0, vm.RU_UserLoginList.length, ...userLoginList);
                        }
                    }
                });
            },
            filterRUPropertyList(optionName) {
                var vm = this;
                vm.isFilterOptionSelected = true;
                vm.selectedFilter = optionName;
                //var selectedOptionList = vm.viewOptionsList.filter(function(option) {
                //  console.log(selectedOptionList)
                //  return option.isChecked == true;
                //});
                vm.updateRUClientDetailList(vm.RU_UserLoginList[0].UserName);
                $("#viewOptionsList").removeClass("show");
            },
            clearSearchText(event) {
                var vm = this;
                vm.searchText = "";
                vm.isFilterOptionSelected = false;
                vm.updateRUClientDetailList(vm.RU_UserLoginList[0].UserName)
                $(".dropdownMenuList").removeClass("show");
                event.stopPropagation();
            },
            update_Unit(event, RUproperty, statusId) {
                var vm = this;
                // event.stopPropagation();
                if (statusId == 5 || statusId == 6) {
                    console.log("Create Unit Action")
                    vm.PullData_RUSpecProp(RUproperty, statusId);
                    vm.updateRUClientDetailList(vm.RU_UserLoginList[0].UserName);
                    $('.dropdown.open .dropdown-toggle').dropdown('toggle');
                } else {
                    vm.openPopup(RUproperty, statusId);
                }
            },
            PullData_RUSpecProp(RUproperty, statusId) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "PullData_RUSpecProp",
                    params: {
                        username: vm.RU_UserLoginList[0].UserName,
                        password: vm.RU_UserLoginList[0].Password,
                        propertyId: RUproperty.CrsPropertyId,
                        UnitId: RUproperty.UnitId,
                        CrsId: 2,
                        isPullData: statusId == 1 ? true : false,
                        createType: statusId,
                    },
                    callback: function (error, response) {
                        if (error) {
                            console.log("error PullData_RUSpecProp == ", error)
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                message: "Error!",
                                header: "Unable to pull data from RU"
                            });
                            return
                        }
                        console.log("PullData_RUSpecProp response", response);
                        vm.$store.dispatch("toastr", {
                            type: "success",
                            message: "Success!",
                            header: "Pull data from RU is success"
                        });
                        // vm.$refs.RuIntegration.pullPropertyList(vm.RU_UserLoginList[0]);
                        vm.updateRUClientDetailList(vm.RU_UserLoginList[0].UserName)
                        if (statusId == 5 || statusId == 6) {
                            // vm.$store.state.bus.$emit("pullRUSpecProp", response);
                            response.rentalUnitedClient = vm.RU_UserLoginList[0]
                            vm.$store.commit('setpullRUSpecProp', response);
                            let propertyId = -1;
                            let unitId = -99;
                            let redirectDetail = statusId == 5 ? "unitDetail" : "unitTypeDetail";
                            vm.$router.push("/" + redirectDetail + "/" + unitId + "/" + propertyId + "?crsPropertyId=" + RUproperty.CrsPropertyId);
                        }
                    }
                });
            },
            openPopup(RUproperty, statusId) {
                var vm = this;
                vm.selectedRUProperty = {};
                vm.selectedStatusId = 0;
                vm.selectedRUProperty = RUproperty;
                vm.selectedStatusId = statusId;

                vm.isModalVisible = true;

                var message = "";
                var title = "";
                switch (vm.selectedStatusId) {
                    case 1:
                        title = "Pull Data",
                            message = "Do you want to pull the data?";
                        break;
                    case 2:
                        title = "Push Data",
                            message = "Do you want to push the data?";
                        break;
                    case 3:
                        title = "Activate",
                            message = "Do you want to Activate?";
                        break;
                    case 4:
                        title = "Inactivate"
                        message = "Do you want to Inactivate?";
                        break;
                    case 6:
                        title = "Push Inventory, Rates, Restrictions",
                            message = "Do you want to Sync/Push Inventory, Rates, Restrictions?";
                        break;
                }

                vm.modalParams = {
                    popupTitle: title,
                    popupMessage: message,
                    isRUPopup: true,
                    yesButtontext: "Yes",
                    noButtonText: "No",
                    yesButtonCallback: vm.updateProcess,
                    noButtonCallback: vm.closePopup
                };
            },
            closePopup(event) {
                let vm = this;
                vm.isModalVisible = false;
                vm.selectedRUProperty = {};
                vm.selectedStatusId = 0;
                vm.isDropdownOpen = false;
                if (event)
                    event.stopPropagation();
            },
        },
        mounted() {
            // Mounted
            this.updateRUClientDetailList(this.ruClientName);
        },
    };
</script>